// extracted by mini-css-extract-plugin
module.exports = {"parameterSpacingRight":".5rem","parameterButtonPadding":"1rem"};